export const API_BASE_URL = process.env.NODE_ENV === 'production'
    ? 'https://backend.paperportal.in/api'
    : (process.env.REACT_APP_API_URL || 'http://localhost:5000/api');

// export const API_BASE_URL = 'https://backend.paperportal.in/api';
